import { gateway } from "../../../gateway";
import { ICreateEventDeliveryConfigPayload, IEventDeliveryConfig } from "../interfaces";

export const createEventDeliveryConfig = async (payload: ICreateEventDeliveryConfigPayload): Promise<IEventDeliveryConfig> => {
  const response = await gateway.post("/event-delivery/config", payload);
  return response?.data?.data;
};
